// Generic launch-config resolution shared across game clients. Parses the
// operator launch URL for the game-gateway base, the single-use launch token,
// and the allowed parent (postMessage) origins. The launch token is returned
// for immediate consumption and is NEVER persisted by this helper.
/**
 * Resolves launch configuration from the launch URL. `gateway` selects the
 * game-gateway API base; `launch_token` is the single-use token; `parent` is
 * the embedding lobby origin merged with any build-time origins. A gateway URL
 * must never be supplied as a parent origin.
 */
export function resolveLaunchConfig(opts = {}) {
    const search = opts.search ?? (typeof window !== 'undefined' ? window.location.search : '');
    const params = new URLSearchParams(search);
    // Callers (each game client) supply defaultGatewayBaseUrl from build-time env;
    // no shared localhost fallback here so production bundles do not embed dev URLs.
    const gatewayBaseUrl = params.get('gateway') ?? opts.defaultGatewayBaseUrl ?? '';
    const launchToken = params.get('launch_token') ?? '';
    const lang = (params.get('lang') ?? '').trim();
    const parentParam = params.get('parent') ?? '';
    const envOrigins = Array.isArray(opts.envParentOrigins)
        ? opts.envParentOrigins
        : (opts.envParentOrigins ?? '').split(',');
    const allowedParentOrigins = Array.from(new Set([parentParam, ...envOrigins].map((s) => s.trim()).filter((s) => s.length > 0)));
    return {
        gatewayBaseUrl,
        launchToken,
        allowedParentOrigins,
        ...(lang ? { locale: lang } : {}),
    };
}
//# sourceMappingURL=config.js.map